<template>
  <v-container fluid>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" :disabled="readonly">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Informations complémentaires</legend>
        <h4>Si vous avez des informations complémentaires à ajouter, veuillez les inscrire dans le champ texte suivant</h4>
        <v-textarea v-model="demandeAdmission.notes" clear-icon="mdi-close-circle" clearable outlined placeholder="Note additionnelle"></v-textarea>
      </fieldset>
    </v-form>

    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn color="secondary" @click="saveAndContinueLater()">Enregistrer et terminer plus tard</v-btn>
      <v-btn color="primary" @click="saveAndContinue()">Procéder au paiement</v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loader from "../Loader";
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin";
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin";

export default {
  mixins: [NavigationPageFormulaireMixin, PageReadonlyFormulaireAdmissionMixin],
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Loader: Loader,
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      message: "",
    };
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmissionPA/GET_DEMANDEADMISSIONID",
      demandeAdmission: "DemandeAdmissionPA/GET_DEMANDEADMISSION",
      factureURL: "Facture/GET_FACTUREURL",
    }),
  },
  created() {
    this.fetchItems();
  },
  methods: {
    ...mapMutations({
      setGenererLaFacture: "DemandeAdmissionPA/SET_GENERERFACTURE",
    }),
    ...mapActions({
      fetchDemandeAdmission: "DemandeAdmissionPA/fetchDemandeAdmission",
      updateDemandeAdmission: "DemandeAdmissionPA/updateDemandeAdmission",
      getLienFactureByDemandeAdmissionId: "Facture/getLienFactureByDemandeAdmissionId",
      envoiConfirmation: "DemandeAdmissionPA/envoiConfirmation",
      synchronisationInfosContactDemandeAdmission: "DemandeAdmission/synchronisationInfosContact",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading";
        this.overlay = true;

        if (this.demandeAdmissionId) {
          await this.fetchDemandeAdmission(this.demandeAdmissionId);
        }

        this.overlay = false;
      } catch (erreur) {
        console.log(erreur);
      }
    },
    saveAndContinueLater() {
      this.redirectValue = "later";

      if (this.readonly) {
        return this.redirect();
      }

      this.messageSelector = "Save";
      this.envoiLien().then(() => {
        this.saveLater();
        this.redirect();
      });
    },
    async saveAndContinue() {
      this.redirectValue = "continue";
      this.messageSelector = "Facture";

      if (this.readonly) {
        this.overlay = true;
        await this.getLienFactureByDemandeAdmissionId(this.demandeAdmissionId);
        return this.redirect();
      }

      await this.saveContinue();
      this.envoiConfirmation().then(() => {
        this.redirect();
      });
    },
    async saveLater() {
      try {
        if (this.demandeAdmission) {
          this.overlay = true;
          this.demandeAdmission.id = this.demandeAdmissionId;
          this.demandeAdmission.creationDuContact = false;
          this.setGenererLaFacture(false);
          await this.updateDemandeAdmission(this.demandeAdmission);
        }
      } catch (err) {
        console.log(err.message);
        this.$router.push({
          name: "InternalError",
          params: { message: "Une erreur est survenue lors de la sauvegarde. <br/> Veuillez contacter l'Ordre." },
        });
      }
    },
    async saveContinue() {
      try {
        if (this.demandeAdmission) {
          this.overlay = true;
          this.demandeAdmission.id = this.demandeAdmissionId;
          this.demandeAdmission.creationDuContact = true;
          this.setGenererLaFacture(true);
          await this.updateDemandeAdmission(this.demandeAdmission);
          await this.synchronisationInfosContactDemandeAdmission(this.demandeAdmission);
          await this.getLienFactureByDemandeAdmissionId(this.demandeAdmissionId);
        }
      } catch (err) {
        console.log(err.message);
        this.$router.push({
          name: "InternalError",
          params: { message: "Une erreur est survenue lors de la génération de votre facture. <br/> Veuillez contacter l'Ordre." },
        });
      }
    },
    redirect() {
      if (this.redirectValue == "later") {
        this.$router.push({ name: "TerminerPlusTard", query: { ...this.$route.query } });
      } else if (this.redirectValue == "continue") {
        window.location.replace(this.factureURL);
      }
    },
  },
};
</script>

<style scoped>
.v-overlay__content {
  position: relative;
  display: flex;
  flex-direction: column;
}
</style>
